function initNewsletterAfterFetch() {
  // Load external script if not already loaded
  if (!window.mlWebformsLoaded) {
    var script = document.createElement('script');
    script.src = "https://groot.mailerlite.com/js/w/webforms.min.js?v95037e5bac78f29ed026832ca21a7c7b";
    script.type = "text/javascript";
    script.onload = function() {
      window.mlWebformsLoaded = true;
    };
    document.body.appendChild(script);
  } else {
    console.log('Newsletter script already loaded.');
  }
}


window.ml_webform_success_38914050 = function() {
  console.log('ml_webform_success_38914050 fired');
  // Show the success row
  var successRow = document.querySelector('.ml-subscribe-form-38914050 .row-success');
  if (successRow) {
    successRow.style.display = 'block';
  }
  // Hide the form row
  var formRow = document.querySelector('.ml-subscribe-form-38914050 .row-form');
  if (formRow) {
    formRow.style.display = 'none';
  }
}

initNewsletterAfterFetch();

// Prevent default form submission for MailerLite form
document.addEventListener('DOMContentLoaded', function() {
  var form = document.querySelector('.ml-subscribe-form-38914050 form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      // Let MailerLite handle the AJAX submission
    });
  }
});